module.exports = __webpack_public_path__ + "3109bec4fd3d98d962b87a3d22850d1e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/li.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/li.svg
// module chunks = 0